import React from 'react';
import UploadIcon from 'src/common/utils/TableColumnIcons/UploadIcon';
import { UploadFileMinos } from 'src/pages/Files/UpaloadFileMinos';

export const ActionColumnUpload = (
	value,
	row,
	rowIndex,
	{ onUploadedFile, allFiles, uniques, setLoader }
) => {
	return (
		<>
			<UploadFileMinos
				control={
					<UploadIcon
						id={'BtnuploadMinos' + row.idEntidad + 'NuevaVersion'}
						title="Nueva Version"
					/>
				}
				onUploaded={onUploadedFile}
				idEntidad={row.idEntidad}
				tipo={row.tipo}
				entidad={row.entidad}
				ruta={'Orden/' + row.idEntidad + '/'}
				title={'Nueva Version'}
				setOpen={setLoader}
				adicional={true}
				allFiles={allFiles}
				uniques={uniques}
			/>
		</>
	);
};
